// extracted by mini-css-extract-plugin
export default {"resource-wrapper":"SelectedResource_resource-wrapper__6KT4p","remove-button":"SelectedResource_remove-button__5ipNe"};